module.exports = __webpack_public_path__ + "media/components/Subscription/powered_by_stripe-db494282f8790aa46e813b229a04437e.svg";